import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7de33392"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Calculations" }
const _hoisted_2 = { class: "Calculations__header" }
const _hoisted_3 = { class: "header__actions" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-upload" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calculator" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!
  const _component_calculation_edit_modal = _resolveComponent("calculation-edit-modal")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_iconRefresh = _resolveComponent("iconRefresh")!
  const _component_calculation_filters = _resolveComponent("calculation-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.preview_state.is_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          class: "large DiscountActions",
          title: "Предварительный транскрипт",
          loading: _ctx.state.is_loading,
          onCancel: _ctx.closeTranscriptPreview,
          onConfirm: _ctx.previewTranscript
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_select, {
              "can-deselect": "",
              placeholder: "Компания",
              loading: _ctx.data_state.companies.is_loading,
              failed: _ctx.data_state.companies.is_failed,
              "is-invalid": _ctx.state_form$.companyId.$error,
              "validation-errors": _ctx.state_form$.companyId.$errors,
              "error-text": "При получении списка компаний произошла ошибка",
              options: _ctx.data_state.companies.list,
              value: _ctx.preview_state.companyId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.preview_state.companyId) = $event)),
              "infinite-scroll": "",
              onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
              onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
              onSearch: _ctx.searchCompanies,
              onOptionBySearch: _ctx.unshiftFindedCompany
            }, null, 8, ["loading", "failed", "is-invalid", "validation-errors", "options", "value", "onSearch", "onOptionBySearch"]),
            _createVNode(_component_the_input, {
              type: "date",
              placeholder: "Дата доставки от",
              "is-invalid": _ctx.state_form$.deliveredAtFrom.$error,
              "validation-errors": _ctx.state_form$.deliveredAtFrom.$errors,
              value: _ctx.preview_state.deliveredAtFrom,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.preview_state.deliveredAtFrom) = $event)),
              class: "mt-2"
            }, null, 8, ["is-invalid", "validation-errors", "value"]),
            _createVNode(_component_the_input, {
              type: "date",
              placeholder: "Дата доставки до",
              "is-invalid": _ctx.state_form$.deliveredAtTo.$error,
              "validation-errors": _ctx.state_form$.deliveredAtTo.$errors,
              value: _ctx.preview_state.deliveredAtTo,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.preview_state.deliveredAtTo) = $event)),
              class: "mt-2"
            }, null, 8, ["is-invalid", "validation-errors", "value"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.edit_state.is_open)
      ? (_openBlock(), _createBlock(_component_calculation_edit_modal, {
          key: 1,
          "calculation-id": _ctx.edit_state.calculation_id,
          "invoice-number": _ctx.edit_state.invoiceNumber,
          onCancel: _ctx.toggleEdit,
          onUpdated: _ctx.onUpdated
        }, null, 8, ["calculation-id", "invoice-number", "onCancel", "onUpdated"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Вычисления" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/billing/import" }, {
          default: _withCtx(() => [
            _createVNode(_component_the_button, {
              class: "primary small",
              hint: "Массовое прокидывание в биллинг"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/billing/calculations/international/create",
          class: "ml-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_button, {
              class: "primary small",
              hint: "Создание международной накладной"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/billing/calculations/update",
          class: "ml-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_button, {
              class: "primary small actions__refresh",
              hint: "Пересчет вычислений"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_iconRefresh)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_calculation_filters, {
      class: "mt-6",
      loading: _ctx.state.is_loading,
      onSearch: _ctx.applyFilters,
      onResetted: _ctx.resetFilters
    }, null, 8, ["loading", "onSearch", "onResetted"]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка вычислений произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadCalculations(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.BillingCalculationsColumns,
                rows: _ctx.state.list,
                "with-limit": "",
                "pagination-limit": _ctx.filters_state.limit,
                "pagination-total-items": _ctx.state.pagination.total_items,
                "pagination-current-page": _ctx.state.pagination.current_page,
                "pagination-total-pages": _ctx.state.pagination.total_pages,
                onChangePage: _ctx.loadCalculations,
                onChangeLimit: _ctx.onLimitChange
              }, {
                td: _withCtx(({ row, column }) => [
                  (column.key === 'id')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        target: "_blank",
                        to: `/billing/calculations/${row.id}`,
                        class: "Calculations__link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row.id), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(row[column.key]), 1)
                      ], 64))
                ]),
                actions: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_router_link, {
                      to: `/billing/calculations/update-price/${row.id}`,
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_the_button, {
                          class: "primary extra-small",
                          hint: "Редактирование цены"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    (row.transcriptId)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          target: "_blank",
                          to: `/billing/transcripts/${row.transcriptId}`
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_the_button, {
                              hint: "Перейти к транскрипту",
                              class: "primary extra-small"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_the_button, {
                      hint: "Редактировать",
                      class: "yellow extra-small ml-1",
                      onClick: ($event: any) => (_ctx.toggleEdit(row.id, row.invoiceNumber))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_the_button, {
                      hint: "Отметить оплаченным",
                      class: "green extra-small ml-1",
                      onClick: ($event: any) => (_ctx.setCost(row.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}